import Vue from "vue";
import Slideout from '@hyjiacan/vue-slideout'
import '@hyjiacan/vue-slideout/lib/slideout.css'

Vue.use(Slideout);
